<template>
  <div
    class="chip"
    :class="{'is-disabled': disabled}"
  >
    <slot />
    <button
      v-if="closable"
      type="button"
      class="delete"
      @click="$emit('close')"
    />
  </div>
</template>

<script>
export default {
  props: {
    closable: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    }
  }
};
</script>
